import { create } from 'zustand';
import { adminUserApi } from '@api/api-config.ts';
import { AdminUserDetailResponse } from '@api/generated/portal-be-admin';

interface AdminUserDetailStoreState {
  loading: boolean;
  error: string | null;
  user: AdminUserDetailResponse | null;

  loadUserDetail: (userId: number) => Promise<void>;
  clearUser: () => void;
}

export const useCreateAdminUserDetailStore = create<AdminUserDetailStoreState>(set => ({
  loading: false,
  error: null,
  user: null,

  loadUserDetail: async (userId: number) => {
    try {
      set({ loading: true, error: null });

      const response = await adminUserApi.getUserDetail({ userId });

      set({ loading: false, user: response.data });
    } catch (error) {
      set({ loading: false, error: error instanceof Error ? error.message : 'Chyba při načítání detailu uživatele' });
    }
  },

  clearUser: () => {
    set({ user: null, error: null });
  },
}));
